import { BulkOperationResult } from '@rideiq/api/services/Riders';
import { useBulkOperationResultToast } from '@rideiq/shared/components/BulkOperationResultToast';

type RiderStatusAction = 'deactivate' | 'reactivate';

const riderLabel = (count: number) => `${count} ${count === 1 ? 'rider' : 'riders'}`;

export const useBulkRiderStatusToast = () => {
  const { showResultsToast } = useBulkOperationResultToast();

  const showStatusResultsToast = (results: BulkOperationResult[], action: RiderStatusAction) => {
    const failures = results.filter((result) => result.status === 'error');
    const errors = [...new Set(failures.flatMap(({ error }) => (error?.trim() ? [error] : [])))];
    const failureMessage = (count: number) =>
      `Cannot ${action} ${riderLabel(count)} due to error${errors.length ? `: ${errors.join('; ')}` : ''}.`;

    showResultsToast(results, {
      allSucceeded: (count) =>
        count === 0
          ? `0 riders ${action}d.`
          : `Successfully ${action}d ${riderLabel(count)}. Caregivers and riders will be notified via SMS.`,
      allFailed: failureMessage,
      partial: (succeeded, failed) => `Successfully ${action}d ${riderLabel(succeeded)}. ${failureMessage(failed)}`,
    });
  };

  return { showStatusResultsToast };
};
